import { usePlatformStore } from '@/store-pinia/platform'
import * as domainSettingService from '@/service/domainSetting'
import { BranchStatus } from '@/view-models/branch'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const config = useRuntimeConfig()
  if (config.public.CONFIG_ENV === 'local') return

  const nuxtApp = useNuxtApp()
  const $pinia = nuxtApp.$pinia
  const route = to
  const { params, query } = route

  const req = useRequestURL()
  const host = req.host
  const platformStore = usePlatformStore($pinia)

  if (!platformStore.isFunBookV2DomainCustomization) {
    return
  }

  const envSubdomain = config.public.BOOKING_ENGINE_DOMAIN
  const customSubdomain = (!host.startsWith('www') && host.includes(envSubdomain) && host.split(envSubdomain)[0]) || ''

  let domainInfo = {}
  try {
    const hostWithoutPort = host.split(':')[0]

    domainInfo = await domainSettingService.verifyDomainCustomization(nuxtApp.$axios, { domain: hostWithoutPort }).then(res => res.data)
  } catch (error) {
    console.log('verifyDomainCustomization error is: ', error.message)
    if (!customSubdomain) {
      return nuxtApp.runWithContext(() => navigateTo(`${config.public.INVALID_DOMAIN_PAGE}`, { external: true }))
    }
    return nuxtApp.runWithContext(() => navigateTo(config.public.BASE_URL, { redirectCode: 301, external: true }))
  }

  if (domainInfo.funbook_ver !== 2 || domainInfo.branch_status !== BranchStatus.Enabled) {
    throw nuxtApp.runWithContext(() => showError({ statusCode: 404, message: 'Post not found', fatal: true }))
  }

  const isPaymentReturnPath = ['/booking/card-verify-return', '/booking/linepay-purchase', '/booking/grab-verify-return'].some(path =>
    route.path.includes(path)
  )
  const isAttendeeFormPath = route.name?.includes('form-attendee')
  if (route.name?.includes('auth-fb-login') || isPaymentReturnPath || isAttendeeFormPath) {
    return
  }
  if (!platformStore.isFunBookV2Path) {
    const bid = domainInfo.branch_id
    return nuxtApp.runWithContext(() =>
      navigateTo(nuxtApp.$localePath({ name: 'funbook-branch_id-branch', params: { branch_id: bid }, query: { ...query } }))
    )
  }

  if (+params.branch_id !== domainInfo.branch_id) {
    const bid = domainInfo.branch_id
    return nuxtApp.runWithContext(() =>
      navigateTo(nuxtApp.$localePath({ name: 'funbook-branch_id-branch', params: { branch_id: bid }, query: { ...query } }))
    )
  }
})
